import { render, staticRenderFns } from "./BidRecords.vue?vue&type=template&id=3cb7010d&scoped=true"
import script from "./BidRecords.vue?vue&type=script&lang=js"
export * from "./BidRecords.vue?vue&type=script&lang=js"
import style0 from "./BidRecords.vue?vue&type=style&index=0&id=3cb7010d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7010d",
  null
  
)

export default component.exports